import React from 'react';
import { X } from 'lucide-react';

export function AddProcessorModal({ show, onClose, processor, setProcessor, onSave, processorTypes }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-slate-900">Add New Processor</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Processor Name</label>
            <input
              type="text"
              value={processor?.name || ''}
              onChange={(e) => setProcessor({ ...processor, name: e.target.value })}
              className="input-field"
              placeholder="e.g., Global"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Processor Type</label>
            <select
              value={processor?.processor_type || ''}
              onChange={(e) => setProcessor({ ...processor, processor_type: e.target.value })}
              className="input-field"
            >
              <option value="">Select Type</option>
              {processorTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <button onClick={onClose} className="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors">
            Cancel
          </button>
          <button onClick={onSave} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            Add Processor
          </button>
        </div>
      </div>
    </div>
  );
}

export function AddPaymentTypeModal({ show, onClose, paymentType, setPaymentType, onSave }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-slate-900">Add New Payment Type</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Payment Type Name</label>
            <input
              type="text"
              value={paymentType?.name || ''}
              onChange={(e) => setPaymentType({ ...paymentType, name: e.target.value })}
              className="input-field"
              placeholder="e.g., Visa"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Code</label>
            <input
              type="text"
              value={paymentType?.code || ''}
              onChange={(e) => setPaymentType({ ...paymentType, code: e.target.value.toUpperCase() })}
              className="input-field"
              placeholder="e.g., VISA"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Category</label>
            <select
              value={paymentType?.category || 'Card'}
              onChange={(e) => setPaymentType({ ...paymentType, category: e.target.value })}
              className="input-field"
            >
              <option value="Card">Card</option>
              <option value="ACH">ACH</option>
            </select>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <button onClick={onClose} className="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors">
            Cancel
          </button>
          <button onClick={onSave} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            Add Payment Type
          </button>
        </div>
      </div>
    </div>
  );
}
